import { supabase } from "@/lib/supabaseClient";

export type WrongAnswerTiming = "next_morning" | "after_hours";

export type NotificationSettings = {
  enabled: boolean;
  daily_reminder: boolean;
  daily_reminder_time: string; // "HH:MM" 형식
  incomplete_test: boolean;
  wrong_answer_review: boolean;
  wrong_answer_timing: WrongAnswerTiming;
  streak_reminder: boolean;
};

function normalizeReminderTime(time: string): string {
  return time.length >= 5 ? time.slice(0, 5) : time;
}

/** 알림 설정 조회 (없으면 null) */
export async function getNotificationSettings(userId: string): Promise<NotificationSettings | null> {
  const { data, error } = await supabase
    .from("notification_settings")
    .select(
      "enabled, daily_reminder, daily_reminder_time, incomplete_test, wrong_answer_review, wrong_answer_timing, streak_reminder",
    )
    .eq("user_id", userId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  if (!data) {
    return null;
  }

  return {
    ...(data as NotificationSettings),
    daily_reminder_time: normalizeReminderTime((data as NotificationSettings).daily_reminder_time),
  };
}

/** 알림 설정 upsert (부분 업데이트 가능) */
export async function upsertNotificationSettings(
  userId: string,
  settings: Partial<NotificationSettings>,
): Promise<void> {
  const normalizedSettings = settings.daily_reminder_time
    ? { ...settings, daily_reminder_time: normalizeReminderTime(settings.daily_reminder_time) }
    : settings;

  const { error } = await supabase
    .from("notification_settings")
    .upsert({ user_id: userId, ...normalizedSettings }, { onConflict: "user_id" });

  if (error) {
    throw error;
  }
}
